/**
 * TypingIndicator — Animated bouncing dots shown while the agent is thinking.
 *
 * Rendered inside an assistant-style bubble (left-aligned, gray background)
 * to match the chat message layout.
 */

export default function TypingIndicator() {
  return (
    <div className="flex justify-start mb-3">
      <div className="bg-gray-100 rounded-2xl rounded-bl-md px-4 py-3 max-w-[80px]">
        <div className="flex space-x-1.5 items-center h-5">
          <span className="typing-dot w-2 h-2 bg-gray-400 rounded-full" style={{ animationDelay: '0ms' }} />
          <span className="typing-dot w-2 h-2 bg-gray-400 rounded-full" style={{ animationDelay: '150ms' }} />
          <span className="typing-dot w-2 h-2 bg-gray-400 rounded-full" style={{ animationDelay: '300ms' }} />
        </div>
      </div>
    </div>
  );
}
